import React from 'react';

const CreateCampaignModal = ({ 
  showCreateForm, 
  selectedCharity, 
  setShowCreateForm, 
  setSelectedCharity, 
  campaignForm, 
  setCampaignForm, 
  handleCreateCampaign, 
  creating 
}) => {
  if (!showCreateForm || !selectedCharity) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[1001] p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-900">Create Campaign</h3>
          <button onClick={() => { setShowCreateForm(false); setSelectedCharity(null); }} className="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
        </div>
        
        <div className="bg-gray-50 rounded-xl p-4 mb-4">
          <p className="text-sm text-gray-500">Selected Charity</p>
          <p className="font-semibold text-gray-900">{selectedCharity.name}</p>
          <p className="text-xs text-gray-500">{selectedCharity.city}, {selectedCharity.state}</p>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Title</label>
            <input type="text" value={campaignForm.title}
              onChange={(e) => setCampaignForm({...campaignForm, title: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg" data-testid="campaign-title-input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Goal Amount ($)</label>
            <input type="number" value={campaignForm.goal_amount}
              onChange={(e) => setCampaignForm({...campaignForm, goal_amount: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg" data-testid="campaign-goal-input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea value={campaignForm.description}
              onChange={(e) => setCampaignForm({...campaignForm, description: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg" rows={3} data-testid="campaign-desc-input" />
          </div>
          <div className="flex items-center gap-3">
            <input type="checkbox" checked={campaignForm.employer_match_enabled}
              onChange={(e) => setCampaignForm({...campaignForm, employer_match_enabled: e.target.checked})}
              className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-testid="campaign-match-toggle" />
            <label className="text-sm font-medium text-gray-700">Enable Employer Matching</label>
          </div>
          {campaignForm.employer_match_enabled && (
            <div className="grid grid-cols-2 gap-4 pl-7 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Match Ratio</label>
                <select value={campaignForm.employer_match_ratio}
                  onChange={(e) => setCampaignForm({...campaignForm, employer_match_ratio: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white" data-testid="campaign-match-ratio">
                  <option value="0.5">0.5:1</option>
                  <option value="1">1:1</option>
                  <option value="1.5">1.5:1</option>
                  <option value="2">2:1</option>
                  <option value="2.5">2.5:1</option>
                  <option value="3">3:1</option>
                  <option value="4">4:1</option>
                  <option value="5">5:1</option>
                </select>
                <p className="text-[10px] text-blue-600 mt-1">From your matching settings</p>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Cap per Employee ($)</label>
                <input type="number" value={campaignForm.employer_match_cap}
                  onChange={(e) => setCampaignForm({...campaignForm, employer_match_cap: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" data-testid="campaign-match-cap" />
                <p className="text-[10px] text-blue-600 mt-1">From your matching settings</p>
              </div>
            </div>
          )}
        </div>
        
        <div className="flex gap-3 mt-6">
          <button onClick={() => { setShowCreateForm(false); setSelectedCharity(null); }}
            className="flex-1 py-3 border rounded-xl font-medium text-gray-600 hover:bg-gray-50">
            Cancel
          </button>
          <button onClick={handleCreateCampaign} disabled={creating} data-testid="create-campaign-submit"
            className="flex-1 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 disabled:opacity-50">
            {creating ? 'Creating...' : 'Create Campaign'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaignModal;
